<mat-form-field floatLabel="never" fxLayout="column" class="mat-form-select-main">
    <mat-select [formControl]="joinFilterControl" (selectionChange)="onSelectionChanged($event.value)">
        <mat-option value="and">And</mat-option>
        <mat-option value="or">Or</mat-option>
    </mat-select></mat-form-field
>
